import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '知识产权有疑问，来上游新闻免费咨询！';

const route: RouteConfig = {
  path: '/20210401Zscqr',
  name: 'Zscqr',
  component: () => import('./Home.vue'),

  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
